import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular/standalone';

@Injectable({
  providedIn: 'root',
})
export class ScreenByPlatform {
   private _isDesktop = false;

  constructor(
    public platform: Platform,
  ) { 
    this.checkDesktopPlatform();
  }

  checkDesktopPlatform() {
    return this._getDesktopFlag(this.platform.width());
  }

  private _getDesktopFlag(screenWidth:any) {
    const isTablet = this.platform.is('tablet');

    if (screenWidth > 961 && !isTablet) {
      this._isDesktop = true;
    } else {
      this._isDesktop = false;
    }

    return this._isDesktop;
  }

  desktop() {
    return this._isDesktop;
  }
}
